import React from "react";
import UserDropdown from "../../components/Dropdowns/UserDropdown";
import { Link, useLocation } from "react-router-dom";

const Navbar = (): JSX.Element => {
	const location = useLocation();
	return (
		<>
			{/* Navbar */}
			<nav className="absolute top-6 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4">
				<div className="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
					{/* Brand */}
					{location.pathname
						.slice(1)
						.split("/")
						.map((path, index, arr) => {
							const a = arr.slice(0, index + 1);
							return (
								<div
									key={index}
									className="text-white first-letter:uppercase hidden lg:inline-block font-semibold text-2xl"
								>
									<Link className="" to={`/${a.join("/")}`}>
										{path || "Overview"}
									</Link>
									{index !== arr.length - 1 && (
										<span className="mx-2">{" > "}</span>
									)}
								</div>
							);
						})}

					{/* Form */}
					<form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
						<div className="relative flex w-full flex-wrap items-stretch">
							<span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300  bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
								<i className="fas fa-search"></i>
							</span>
							<input
								type="text"
								placeholder="Search here..."
								className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
							/>
						</div>
					</form>
					{/* User */}
					<ul className="relative z-50 flex-col md:flex-row list-none items-center hidden md:flex">
						<UserDropdown />
					</ul>
				</div>
			</nav>
			{/* End Navbar */}
		</>
	);
};

export default Navbar;
